var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-responsive',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"450px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.prettyHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }